// extracted by mini-css-extract-plugin
export default {"image":"image_image__L4haE"};